import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const LanguageView = () => {
  const { id } = useParams();
  const [language, setLanguage] = useState(null);
  const [translations, setTranslations] = useState([]);
  const [loading, setLoading] = useState(true);

   //  Kullanıcının dilini al ve çevirileri getir
   const userLanguage = useUserLanguage();
   const { translations: trans } = useTranslations(userLanguage);
   const getText = (key, defaultValue) => trans[key] || defaultValue;

  useEffect(() => {
    fetchLanguageDetails();

  }, [id]);

  const fetchLanguageDetails = async () => {
    try {
      const token = localStorage.getItem("admin_token");

      // 1) Seçili dilin bilgilerini çek
      const langResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/languages/view/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLanguage(langResp.data);

      // 2) Bu dile ait çevirileri çek
      const transResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/translations/lang/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTranslations(transResp.data); 

    } catch (error) {
      console.error(" Dil bilgisi alınamadı:", error);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center text-secondary">{getText("LOADING_MSG")}</div>
      </div>
    );
  }
  if (!language) {
    return (
      <div className="container mt-4">
        <div className="text-center text-danger">{getText("LANGUAGE_NOT_FOUND")}</div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
     
      <div className="card p-4 shadow-sm">
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h5 className="fw-bold mb-0">{getText("LANGUAGE_DETAILS")}</h5>
        </div>

        <div className="row mb-4">
          <div className="col-lg-2 fw-medium">{getText("TABLE_LANGUAGE_NAME_LABEL")}</div>
          <div className="col-lg-10">{language.name}</div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-2 fw-medium">{getText("LANGUAGE_CODE")}</div>
          <div className="col-lg-10">
            <span className="badge bg-info fs-6">{language.code}</span>
          </div>
        </div>
 
          <div className="row mb-4">
          <div className="col-lg-2 fw-medium">{getText("LANGUAGE_FLAG")}</div>
          <div className="col-lg-10">
            {language.flag ? (
              <img
                src={`http://localhost:4000${language.flag}`} 
                alt="Flag"
                className="me-3"
                style={{ width: "40px", height: "25px", border: "1px solid #ddd", borderRadius: "4px" }}
              />
            ) : (
              <span className="text-muted"> </span>
            )}
          </div>
        </div>


        {/* Logo Önizleme Alanı */}
        <div className="row mb-4">
          <div className="col-lg-2 fw-medium">{getText("LANGUAGE_LOGO")}</div>
          <div className="col-lg-10">
            {language.logo ? (
              <img
                src={`http://localhost:4000${language.logo}`} // Logoyu backend'den al
                alt="Logo"
                className="me-3"
                style={{ width: "280px", height: "80px", border: "1px solid #ddd", borderRadius: "4px" }}
              />
            ) : (
              <span className="text-muted"> </span>
            )}
          </div>
        </div>
    
      </div>

  

  
    </div>
  );
};

export default LanguageView;
